import { render, staticRenderFns } from "./FileUploadZone.vue?vue&type=template&id=0f221adf&scoped=true&"
import script from "./FileUploadZone.vue?vue&type=script&lang=ts&"
export * from "./FileUploadZone.vue?vue&type=script&lang=ts&"
import style0 from "./FileUploadZone.vue?vue&type=style&index=0&id=0f221adf&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f221adf",
  null
  
)

export default component.exports